<template>
  <Transition name="cookiebar">
    <div v-if="!cookieNoticeDismissed" class="cookiebar">
      <button type="button" @click="cookieNoticeDismissed = true">
        <ImagesSvg icon="close" color="white" :width="32" :height="32" />
      </button>
      <BlocksWerkenbijContentArea :content="{ propertyName: null, value: body }" />
    </div>
  </Transition>
</template>

<script lang="ts" setup>
import type { XhtmlStringResponseModel } from '@api';
import { SECONDS_IN_A_YEAR } from '@base/utils/constants';

const cookieNoticeDismissed = useCookie('cookieNoticeDismissed', {
  default: () => false,
  maxAge: SECONDS_IN_A_YEAR,
});

interface CookieBar {
  body: XhtmlStringResponseModel;
  animTime?: number;
}

const props = withDefaults(defineProps<CookieBar>(), {
  animTime: 2,
});

const cAnimInMs = computed(() => props.animTime * ANIMATION_DURATION);
const cAnimTime = computed(() => `${cAnimInMs.value}ms`);
</script>

<style lang="scss" scoped>
.cookiebar {
  position: fixed;
  padding: px(20) px(56) px(20) px(20);
  bottom: 0;
  left: 0;
  right: 0;
  width: 100vw;
  z-index: 60;
  background-color: var(--color-oker);
  color: var(--color-white);

  button {
    position: absolute;
    top: px(16);
    right: px(16);
    border: 0;
    color: var(--color-white);
    background: transparent;
    appearance: none;
    cursor: pointer;
  }

  :deep(p) {
    margin-top: 0;
  }

  :deep(a) {
    color: inherit;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }

  &-leave-active {
    /* stylelint-disable-next-line declaration-property-value-no-unknown -- not yet found a way to disable v-bind errors */
    transition: transform v-bind(cAnimTime) ease;
  }

  &-leave-to {
    transform: translateY(100%);
  }

  @include media-breakpoint-up(lg) {
    padding: px(20) px(160);
  }
}
</style>
